"use strict";

var _regeneratorRuntime = require("/home/travis/build/ulabox/boksa/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.kickOff = exports.selectLanguage = exports.selectCartID = exports.selectCustomerToken = void 0;

var _lang = require("lodash/lang");

var _effects = require("redux-saga/effects");

var _auth = require("@modules/auth");

var _cart = require("@modules/cart");

var _actions = require("./actions");

var selectCustomerToken = function selectCustomerToken(state) {
  return state.auth.customerToken;
};

exports.selectCustomerToken = selectCustomerToken;

var selectCartID = function selectCartID(state) {
  return state.cart.id;
};

exports.selectCartID = selectCartID;

var selectLanguage = function selectLanguage(state) {
  return state.account.language;
};

exports.selectLanguage = selectLanguage;

var kickOff =
/*#__PURE__*/
_regeneratorRuntime.mark(function kickOff() {
  var customerToken, cartID;
  return _regeneratorRuntime.wrap(function kickOff$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(selectCustomerToken);

        case 3:
          customerToken = _context.sent;
          _context.next = 6;
          return (0, _effects.select)(selectCartID);

        case 6:
          cartID = _context.sent;

          if (!customerToken) {
            _context.next = 12;
            break;
          }

          _context.next = 10;
          return (0, _effects.put)(_auth.authActions.fetchRefreshCustomerToken(customerToken));

        case 10:
          _context.next = 12;
          return (0, _effects.take)(_auth.authActions.SET_CUSTOMER_TOKEN);

        case 12:
          _context.next = 14;
          return (0, _effects.put)(_cart.cartActions.fetchCart(cartID, (0, _lang.isEmpty)(cartID) && 1));

        case 14:
          _context.next = 19;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, kickOff, this, [[0, 16]]);
});

exports.kickOff = kickOff;

var appshell =
/*#__PURE__*/
_regeneratorRuntime.mark(function appshell() {
  return _regeneratorRuntime.wrap(function appshell$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_actions.KICK_OFF, kickOff);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, appshell, this);
});

var _default = appshell;
exports.default = _default;